module.exports = __webpack_public_path__ + "img/one.svg.956bf23a.svg";